<template>
  <v-card
    color="grey lighten-4"
    width="350px"
    flat>
    <v-toolbar
      color="orange"
      dark
    >
      <v-toolbar-title>
        <v-row class="mx-1" align="center">
        Add a Time
        </v-row>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-row justify="center" align="center">
        <v-col cols="5">
          <v-autocomplete
            v-model="startTime"
            :items="allTimes.slice(0, -1)"
            color="orange" />
        </v-col>
        <h3>&mdash;</h3>
        <v-col cols="5">
          <v-autocomplete
            v-model="endTime"
            :items="allEndTimes"
            color="orange" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-row justify="end">
        <v-btn
          color="orange"
          text
          @click="$emit('cancel')"
        >
          Cancel
        </v-btn>
        <v-btn
          color="orange"
          text
          @click="submit"
        >
          Add Time
        </v-btn>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'TimePickerCard',

  data: () => ({
    startTime: '9:00am',
    endTime: '5:00pm'
  }),

  methods: {
    submit () {
      this.$emit('addTime', {
        startTime: this.startTime,
        endTime: this.endTime
      })
    },

    getEndTime () {
      var startTimeIndex = this.allTimes.indexOf(this.startTime)
      return this.allTimes[startTimeIndex + 1]
    }
  },

  computed: {
    allTimes () {
      const interval = 15
      const meridiems = ['am', 'pm']
      var firstTime = 0

      var ret = []
      // loop to increment the time and push results in array
      for (var i = 0; firstTime < 24 * 60; i++) {
        // get hours of the day in 24h format
        var hh24 = Math.floor(firstTime / 60)
        // get hours of day in 12h format
        var hh12 = (hh24 === 0 ? 12 : hh24 % 12).toString().slice(-2)
        if (hh12 === '0') hh12 = 12

        // getting minutes of the hour in 0-55 format
        var mm = ('0' + firstTime % 60).slice(-2)

        var time = hh12 + ':' + mm + meridiems[Math.floor(hh24 / 12)]
        ret.push(time)
        firstTime = firstTime + interval
      }

      return ret
    },

    allEndTimes () {
      var startTimeIndex = this.allTimes.indexOf(this.startTime)
      // only take end times that are after the start time
      return this.allTimes.slice(Math.max(startTimeIndex + 1, 1))
    }
  },

  watch: {
    startTime: function () {
      this.endTime = this.getEndTime()
    }
  }
}
</script>
